// extracted by mini-css-extract-plugin
module.exports = {"tag_cloud":"styles_tag_cloud__xCrdc","singleTag":"styles_singleTag__b6ngu","activeTag":"styles_activeTag__3xhda"};